import { AuthRepository } from '@auth/domain/repositories/AuthRepository'
import { HTTPDatasource } from '@auth/infra/datasource/HTTPDatasource'
import NotImplementedError from '@shared/exceptions/NotImplementedException'

import { EmailResponse } from '../../domain/models/EmailResponse'
import Refresh from '../../external/refresh'

export function AuthRepositoryAdapter(
  datasource: HTTPDatasource
): AuthRepository {
  return {
    async login(login) {
      return await datasource.post('/login', {
        login: login.login.trim(),
        password: login.password.trim()
      })
    },

    signup() {
      throw new NotImplementedError()
    },

    logout() {
      throw new NotImplementedError()
    },

    async refresh(token) {
      return await Refresh.refresh(token)
    },

    async sendEmailLoginCode({ doc }) {
      return (await datasource.put('/v1/users/username', {
        doc: doc
      })) as unknown as Promise<EmailResponse>
    },
    async sendEmailCode({ doc }) {
      return (await datasource.put('/v1/users/passwords', {
        doc: doc
      })) as unknown as Promise<EmailResponse>
    },

    async testVerificationCode({ code }) {
      return await datasource.post('/v1/users/passwords/codes', {
        code
      })
    },
    async testVerificationLogin({ code }) {
      return await datasource.post('/v1/users/username/codes', {
        code
      })
    },

    async changePassword(passwordUpdate) {
      return await datasource.put('/v1/users/passwords/codes', {
        code: passwordUpdate.code,
        userDoc: passwordUpdate.userDoc,
        newPassword: passwordUpdate.newPassword
      })
    }
  }
}
